import React from "react";

function PaperPlane() {
  return (
    <span className="anticon ant-plane">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 22 19"
      >
        <path
          fill="#0096dc"
          fillRule="nonzero"
          stroke="currentColor"
          strokeWidth="0.8"
          d="M1.002 9.488a.95.95 0 00.68.86l7.184 2.172.264 4.952a.491.491 0 00.492.46c.14 0 .272-.056.368-.164l2.54-2.812 3.6 2.492c.16.112.348.172.544.172.452 0 .844-.32.94-.768l2.988-15.228a.49.49 0 00-.664-.548L1.578 8.548a.965.965 0 00-.576.94zm9.04 6.756l-.164-3.124 1.84 1.272-1.676 1.852zm6.616.38l-6.552-4.536L19.294 3.2l-2.636 13.424zm1.628-13.816l-9.084 8.788-7.176-2.168 16.26-6.62z"
        ></path>
      </svg>
    </span>
  );
}

export default PaperPlane;
